module.exports = __webpack_public_path__ + "static/media/10.b03180dd.jpeg";